import React, { useEffect, useState } from "react";
import { pick } from "underscore";
import { CSVReader } from "react-papaparse";
import { Button, Modal, Alert as BSAlert, Row, Col } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import { CSVLink } from "react-csv";
import { useMutation, queryCache } from "react-query";
import Alert from "react-s-alert";
import { injectIntl, FormattedMessage } from "react-intl";
import { DateTime } from 'luxon';
import { connect } from "react-redux";

// import { batchPostSpeakers } from "./xhr";
import ProfileModal from '../../../components/ProfileModal';
import { UploadCsv, DownloadCsv } from '../../../components/svgs';
import { cleanObjectAndReturn } from "../../../helpers/cleanObject"
import { batchPostPresentation } from "./xhr";
import { YesNo } from "../../../formik";
import { purchaseCredits } from "../../../redux/actions/user";

export const ExportPresentations = ({ data, event_name, foreign: { rooms, speakers, colors = [], types = [], associations = [], sessions = [] } }) => {
  return (
    <CSVLink
      data={data.map((row) => {
        const room = rooms.find(r => r._id === row.room_id);
        const speaker = speakers.find(s => s._id === row.speaker_id);
        const color = colors.find(c => c._id === row.color_id);
        const type = types.find(t => t._id === row.type_id);
        const association = associations.find(a => a._id === row.association_id);
        const session = sessions.find(s => s._id === row.session_id);
        return {
          ...row,
          date: DateTime.fromISO(row.date).setLocale('fr').toLocaleString(DateTime.DATE_SHORT),
          room: room ? room.name : '',
          speaker: speaker ? speaker.email : '',
          color: color ? color.name : '',
          type: type ? type.name : '',
          association: association ? association.name : '',
          session: session ? session.name : '',
          pdfConvert: row.pdfConvert ? 1 : 0,
          publicVideo: row.publicVideo ? 1 : 0
        }
      }).map((row) =>
        pick(
          row,
          "name",
          "date",
          "skip",
          "time",
          "end_time",
          "room",
          "speaker",
          "color",
          "type",
          "association",
          "session",
          "information",
          "pdfConvert",
          "publicVideo",
          "externalPdfLink"
        )
      )}
      headers={[
        { label: "Name", key: "name" },
        { label: "Date", key: "date" },
        { label: "Passer les seconds", key: "skip" },
        { label: "Heure de début", key: "time" },
        { label: "Heure de fin", key: "end_time" },
        { label: "Salle de conférence", key: "room" },
        { label: "Intervenant", key: "speaker" },
        { label: "Thème", key: "color" },
        { label: "Type", key: "type" },
        { label: "Association", key: "association" },
        { label: "Session", key: "session" },
        { label: "Information", key: "information" },
        { label: "PDF Convert", key: "pdfConvert" },
        { label: "Vidéo publique", key: "publicVideo" },
        { label: "External PDF Link", key: "externalPdfLink" },
      ]}
      filename={`${event_name} - presentations.csv`}
    >
      <Button variant="primary">
        <DownloadCsv />
        <FormattedMessage id="export.presentation-list" />
      </Button>
    </CSVLink>
  );
};

const _ImportPresentations = injectIntl(({ intl, event, purchaseCredits }) => {
  const [show, setShow] = useState(false);
  const [dateError, setDateError] = useState({
    row: -1,
    date: "",
  })
  const [records, setRecords] = useState([]);

  const [acceptCharge, setAcceptCharge] = useState(0);
  const [creditsToBePurchased, setCreditsToBePurchased] = React.useState(0);
  const [showCreditPurcahseModal, setShowCreditPurcahseModal] = React.useState(false);
  const [showAccount, setShowAccount] = React.useState(false);

  const [batchPostPresentationMutation, { isLoading, isError, error, data }] = useMutation(batchPostPresentation, {
    onSuccess: (insertedPresentations) => {
      queryCache.setQueryData(["event-presentations", event._id], () => insertedPresentations);
      Alert.success(intl.formatMessage({ id: "presentation.create-success" }));
      setCreditsToBePurchased(0);
    },
    onError: (err) => {
      if (err.response.data.message === "error.chargeable-action") {
        setAcceptCharge(err.response.data.details["credits-required"]);
      }

      if (err.response.data.message === "error.not-enough-credits") {
        setCreditsToBePurchased(err.response.data.details["credits-required"]);
        setShowCreditPurcahseModal(!showCreditPurcahseModal);
      }
      Alert.error(intl.formatMessage({ id: err.response.data.message }));
    },
  });

  useEffect(() => {
    if(records.length === 0) {
      return;
    }
    const doBatchPostPresentationMutation = async () => {
      await batchPostPresentationMutation({
        event_id: event._id,
        presentations: records,
      })
    }
    doBatchPostPresentationMutation();
  }, [event._id, records, batchPostPresentationMutation]);

  return (
    <div>
      <Button
        variant="primary"
        onClick={() => setShow(true)}
      >
        <UploadCsv />
        <FormattedMessage id="import.presentation-list" />
      </Button>
      <Modal
        // className="profile-modal-container"
        show={show}
        onHide={() => setShow(!show)}
        // dialogClassName="profile-modal"
        // backdropClassName="profile-modal-backdrop"
        // aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Import CSV
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            intl.locale === 'fr' ?
            <div className="csv-rules">
              <strong>Règles de chargement des fichiers:</strong>
              <ul>
              <li>Charger uniquement des fichiers CSV.</li>
              <li>Le fichier à charger doit contenir une entête avec le nom des colonnes.</li>
              <li>La caractère de séparation est la virgule ",".</li>
              <li>Le format de la date est <strong>DD/MM/YYYY.</strong></li>
              <li>Le format de l'heure est <strong>HH:MM.</strong></li>
              <li>Le format de l'intervenant est <strong>l'e-mail</strong>.</li>
              <li>Les autres champs sont au format texte.</li>
              <li>Si la présentation chargée existe déjà alors elle est modifiée.</li>
              <li>Si la présentation chargée n'existe pas alors elle est créée.</li>
              <li>Si l'intervenant ou le thème ou le type ou l'association ou la session ou la salle de conférence n'existe pas alors la présentation n'est pas chargée.</li>
              </ul>
            </div>
            :
            <div  className="csv-rules">
              <strong>Loading rules:</strong>
              <ul>
              <li>Load only CSV file.</li>
              <li>The file must contain one header. The hearder is the list of the column.</li>
              <li>The separator character is the comma ",".</li>
              <li>Date format is <strong>DD/MM/YYYY</strong></li>
              <li>Time format is <strong>HH:MM</strong></li>
              <li>Speaker format is the <strong>email</strong></li>
              <li>All other colmun are in text format</li>
              <li>If the presentation loaded already exists then the presentation is updated.</li>
              <li>If the presentation loaded already doesn't exist then the presentation is created.  </li>
              <li>If Speaker, or Theme or Type or Association or Session or Room doesn't exist then the records are not loaded.</li>
              </ul>
            </div>
          }
          <CSVReader
            onDrop={async (data) => {
              setDateError({ row: -1, date: "" });

              if(data.length === 0) {
                alert("No rows were found.");
                setRecords([]);
                return;
              }

              if(data[0].data[0] === "Name" && data[0].data[1] === "Date") {
                // if header is present
                data = data.slice(1)
              }

              try {
                for(let i = 0; i < data.length ; i++) {
                  if(!DateTime.fromFormat(data[i].data[1], "d/M/y").isValid) {
                    setDateError({
                      row: i + 1,
                      date: data[i].data[1],
                    })
                    setRecords([]);
                    return;
                  }
                }
                const presentations = data.map(d => cleanObjectAndReturn({
                  name: d.data[0],
                  date: d.data[1],
                  skip: d.data[2],
                  time: d.data[3],
                  end_time: d.data[4],
                  room: d.data[5],
                  speaker: d.data[6],
                  color: d.data[7],
                  type: d.data[8],
                  association: d.data[9],
                  session: d.data[10],
                  information: d.data[11],
                  pdfConvert: !!d.data[12],
                  publicVideo: !!d.data[13],
                  externalPdfLink: d.data[14],
                })).filter(d => Object.keys(d).length !== 0)

                if(presentations.length === 0) {
                  alert("No rows were found.");
                  setRecords([]);
                  return;
                }

                setRecords(presentations);
              } catch (e) {
                alert(e);
              }
            }}
            onError={(err) => {
              setRecords([]);
              console.log("onError: ", err);
            }}
            style={{}}
            config={{
              dynamicTyping: true,
              skipEmptyLines: 'greedy',
            }}
          >
            <span><FormattedMessage id="drop-click-csv" /></span>
          </CSVReader>
          {
            isLoading && <i>{intl.formatMessage({id: 'processing.csv'})}</i>
          }
          {
            isError && <ErrorHandler data={error.response.data} intl={intl} />
          }
          {
            dateError.row !== -1 && <div><br /><BSAlert variant="danger"> { intl.locale === 'fr' ? `de la date est invalide pour la ligne ${dateError.row}, la valeur en erreur est ${dateError.date}` : `Invalid date format in Row ${dateError.row}, found value ${dateError.date}` }</BSAlert></div>
          }
          {
            data && <div><br /><BSAlert variant="success"><FormattedMessage id="success.import" /></BSAlert></div>
          }
          {acceptCharge !== 0 &&
            <Formik initialValues={{
                purchase: false,
              }}
              onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                console.log('debug: ', {
                  ...values,
                  event_id: event._id,
                  presentations: records,
                });
                await batchPostPresentationMutation({
                  ...values,
                  event_id: event._id,
                  presentations: records,
                })
                setSubmitting(false);
            }}
            >
              {({ isSubmitting }) =>
                <Form>
                  <Row>
                    <Col>
                      <Field id="accept-charge" className="checkbox-custom" name="purchase" component={YesNo} label={`${intl.formatMessage({ id: 'accept.charge' })} ${acceptCharge} ${intl.formatMessage({ id: 'user.creds' })}s`} />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button type="submit" disabled={isSubmitting}>Import</Button>
                    </Col>
                  </Row>
                </Form>
              }
            </Formik>
          }
        </Modal.Body>
      </Modal>

      <Modal
        show={showCreditPurcahseModal !== false}
        onHide={() => { setShowCreditPurcahseModal(!showCreditPurcahseModal) }}
        size="small"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FormattedMessage id="heading.purchase-credits" />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <center>
            <Button
              variant="primary"
              onClick={() => purchaseCredits(creditsToBePurchased)}
            >
              {intl.formatMessage({id: 'purchase.text'})} {creditsToBePurchased} {intl.formatMessage({id: 'user.creds'})}{creditsToBePurchased > 2 ? 's' : ''} {intl.formatMessage({id: 'for.text'})} {" "}{creditsToBePurchased * process.env.REACT_APP_COST_PER_CREDIT}{" "}Euros
              </Button>
            <br />
            <br />
            <Button onClick={() => setShowAccount(!showAccount)} variant="default">{intl.formatMessage({id: 'link-credit-card'})}</Button>
            <ProfileModal show={showAccount} setShow={(bool) => setShowAccount(bool)} />
          </center>
        </Modal.Body>
      </Modal>
    </div>
  );
});

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {
    purchaseCredits: (credits) => dispatch(purchaseCredits(credits)),
  };
};

export const ImportPresentations = connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(_ImportPresentations));

const ErrorHandler = ({ data, intl }) => {
  if(data.message === "error.items-to-be-created") {
    return <div>
      <br />
      <BSAlert variant="danger"><FormattedMessage id={data.message} /></BSAlert>
      {Object.keys(data.details).map((key) => {
        return <ul key={key}>
          <li>{intl.formatMessage({ id: `input.presentation.${key}`})}</li>
          <ol>
            {
              data.details[key].map((val) => <li key={val}>{val}</li>)
            }
          </ol>
        </ul>
      })}
    </div>
  }

  return <div><br /><BSAlert variant="danger"><FormattedMessage id={data.message} /></BSAlert></div>
}
